import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Detail_omrResult.scss';
import fnc from '../../mymod/commFunction';
import MathMarkdown from '../../page_aiEssay/components/MathMarkdown';

const shouldShowAnswerDetail = (value) => {
  const answer = String(value ?? '').trim();
  return answer.length > 18 || /[\n\\$]/.test(answer);
};

const ResultAnswerPreview = ({ value, onOpen }) => {
  const answer = String(value ?? '').trim();
  if (!answer) return <span className="result-answer-preview__empty">-</span>;

  const showDetail = shouldShowAnswerDetail(answer);
  return (
    <div className="result-answer-preview">
      <div className="result-answer-preview__content">
        <MathMarkdown value={answer} renderBareLatex />
      </div>
      {showDetail && (
        <button type="button" className="result-answer-preview__button" onClick={onOpen}>
          상세
        </button>
      )}
    </div>
  );
};

const Detail_omrResult = () => { 
    const [list, setList] = useState([]);
    const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);

    const [score, setScore] = useState(null);
    const [avg, setAvg] = useState(null);
    const [cnt, setCnt] = useState(null);
    const [answerDetail, setAnswerDetail] = useState(null);

  const fncSelect_list = useCallback(() => {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lms/omr/result', { acaCode, stCode, parentCode: lmsListCode }, (res) => {
      if (res && Array.isArray(res)) { 
        // console.log(res, '==============res');
        setList(getRecords(res));
      } else {
        console.log(res,"kuesbLmsRoutes/select/lms/course/omrGetDap");
      }
    });
  }, [lmsListCode]);

  const fncSelect_avg = useCallback(() => {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lms/omr/result/avg', { acaCode, stCode, parentCode: lmsListCode }, (res) => {
      if (res) { 
        // console.log(res, '==============avg');
        setScore(res[0].score);
        setAvg(res[0].avg);
        setCnt(res[0].cnt);

      } else {
        console.log(res,"select/lms/omr/result/avg");
      }
    });
  }, [lmsListCode]);

  useEffect(() => {
    fncSelect_list();
    fncSelect_avg();
  }, [fncSelect_avg, fncSelect_list]);

  useEffect(() => {
    if (!answerDetail) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setAnswerDetail(null);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [answerDetail]);

  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const sno= res[i]["sno"];
        const OX= res[i]["OX"];
        const dap = res[i]["dap"];
        const markingValue = res[i]["markingValue"];
        const point = res[i]["point"];//배점
        const item = res[i]["item"];//계산력 ....
        records.push({ sno, dap, markingValue, OX, point, item });
    }
    return records;
  }




  //============================================================================
    return (
        <div className='Detail_omrResult'>
            <div className="omr-result-summary">
              <div>
                <span>내 점수</span>
                <strong>{score ?? '-'}<small>점</small></strong>
              </div>
              <div>
                <span>전체 평균</span>
                <strong>{avg ?? '-'}<small>점</small></strong>
              </div>
              <div>
                <span>응시 인원</span>
                <strong>{cnt ?? '-'}<small>명</small></strong>
              </div>
            </div>
            <div className="title">문항별 채점 결과</div>
            <div className='wrap-main'>
             <section className="section-main">
                <table className="table-hong table-main">
                  <thead>
                    <tr>
                      <th>문항</th>
                      <th>정답</th>
                      <th>마킹</th>
                      <th>OX</th>
                      <th>배점</th>
                      <th>항목</th>
                    </tr>
                  </thead>

                  <tbody>
                      {list && list.map((item, index) => (
      
                          <tr key={index}>  
                            <td data-label="문항">{index+1}</td>
                            <td data-label="정답">
                              <ResultAnswerPreview
                                value={item.dap}
                                onOpen={() => setAnswerDetail({
                                  questionNo: index + 1,
                                  label: '정답',
                                  value: item.dap
                                })}
                              />
                            </td>
                            <td data-label="마킹">
                              <ResultAnswerPreview
                                value={item.markingValue}
                                onOpen={() => setAnswerDetail({
                                  questionNo: index + 1,
                                  label: '내 답',
                                  value: item.markingValue
                                })}
                              />
                            </td>
                            <td
                              data-label="OX"
                              className={item.OX === 'O' ? 'is-correct' : 'is-wrong'}
                            >
                              <span>{item.OX}</span>
                            </td>
                            <td data-label="배점">{item.point}</td>
                            <td data-label="항목">{item.item}</td>
                          </tr>
                      ))}
                
                    </tbody>
                </table>

                <div className="device-result-grid" role="table" aria-label="문항별 채점 결과">
                  <div className="device-result-grid__header" role="row">
                    <span role="columnheader">문항</span>
                    <span role="columnheader">평가 영역</span>
                    <span role="columnheader">정답</span>
                    <span role="columnheader">내 답</span>
                    <span role="columnheader">결과</span>
                    <span role="columnheader">배점</span>
                  </div>
                  {list.map((item, index) => {
                    const isCorrect = item.OX === 'O';
                    return (
                      <div
                        className={`device-result-grid__row ${isCorrect ? 'is-correct' : 'is-wrong'}`}
                        key={item.sno || index}
                        role="row"
                      >
                        <span className="device-result-grid__number" role="cell"><strong>{index + 1}</strong></span>
                        <span className="device-result-grid__category" role="cell">{item.item || '미분류'}</span>
                        <div className="device-result-grid__answer" role="cell">
                          <ResultAnswerPreview
                            value={item.dap}
                            onOpen={() => setAnswerDetail({
                              questionNo: index + 1,
                              label: '정답',
                              value: item.dap
                            })}
                          />
                        </div>
                        <div className="device-result-grid__answer" role="cell">
                          <ResultAnswerPreview
                            value={item.markingValue}
                            onOpen={() => setAnswerDetail({
                              questionNo: index + 1,
                              label: '내 답',
                              value: item.markingValue
                            })}
                          />
                        </div>
                        <span className="device-result-grid__status" role="cell">
                          <em
                            className={isCorrect ? 'result-correct' : 'result-wrong'}
                            aria-label={isCorrect ? '정답' : '오답'}
                          >
                            {isCorrect ? 'O' : 'X'}
                          </em>
                        </span>
                        <span className="device-result-grid__point" role="cell"><strong>{item.point}</strong><small>점</small></span>
                      </div>
                    );
                  })}
                </div>
          </section>
        </div>

        {answerDetail && (
          <div
            className="omr-answer-detail-modal__backdrop"
            role="presentation"
            onMouseDown={() => setAnswerDetail(null)}
          >
            <section
              className="omr-answer-detail-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="omr-answer-detail-title"
              onMouseDown={(event) => event.stopPropagation()}
            >
              <header className="omr-answer-detail-modal__header">
                <h2 id="omr-answer-detail-title">
                  {answerDetail.questionNo}번 {answerDetail.label}
                </h2>
                <button
                  type="button"
                  className="omr-answer-detail-modal__close"
                  aria-label="상세 답안 닫기"
                  onClick={() => setAnswerDetail(null)}
                >
                  ×
                </button>
              </header>
              <div className="omr-answer-detail-modal__content">
                <MathMarkdown value={answerDetail.value} renderBareLatex />
              </div>
              <footer className="omr-answer-detail-modal__footer">
                <button type="button" onClick={() => setAnswerDetail(null)}>닫기</button>
              </footer>
            </section>
          </div>
        )}

     
        </div>
    );
};

export default Detail_omrResult;
